'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateServices = exports.validateAddons = exports.validateAdditionalUnitQuantity = exports.validateTerm = exports.validateEdition = undefined;

var _underscore = require('underscore');

var _Editions = require('self-service-api/constants/Editions');

var Editions = _interopRequireWildcard(_Editions);

var _Terms = require('self-service-api/constants/Terms');

var Terms = _interopRequireWildcard(_Terms);

var _HubToAddonsMap = require('pricing-pages-unified-ui/constants/HubToAddonsMap');

var _HubToServicesMap = require('pricing-pages-unified-ui/constants/HubToServicesMap');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var validateEdition = exports.validateEdition = function validateEdition(edition) {
  return Object.values(Editions || {}).includes(edition);
};

var validateTerm = exports.validateTerm = function validateTerm(term) {
  return Object.values(Terms || {}).includes(term);
};

var validateAdditionalUnitQuantity = exports.validateAdditionalUnitQuantity = function validateAdditionalUnitQuantity(rawValue) {
  try {
    var quantity = JSON.parse(rawValue);
    return quantity > 0 && quantity % 1 === 0;
  } catch (e) {
    return false;
  }
};

var validateAddons = exports.validateAddons = function validateAddons(merchandiseIds) {
  if (!Array.isArray(merchandiseIds)) return false;
  var addons = _HubToAddonsMap.PrimaryAddons.concat(_HubToAddonsMap.AdditionalAddons);
  return (0, _underscore.difference)(merchandiseIds, addons).length === 0;
};

var validateServices = exports.validateServices = function validateServices(merchandiseIds) {
  if (!Array.isArray(merchandiseIds)) return false;
  var services = _HubToServicesMap.MarketingServices;
  return (0, _underscore.difference)(merchandiseIds, services).length === 0;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/validators.js
// module id = 356
// module chunks = 3 4 5